var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"mt-5"},[_c('h3',[_vm._v(_vm._s(_vm.settings.label))]),_c('img',{attrs:{"width":"100%","src":_vm.src,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }